import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Heading, Text } from '@/components/ui/typography';
import { Checkbox } from '@/components/ui/checkbox';
import { Stack } from '@/components/ui/layout';
import { Calendar } from 'lucide-react';
import { cn } from '@/lib/utils';

const ScheduleInterviewModal = ({ len, candidates, onClose, onSelectTest }) => {
  console.log('candidates', candidates);
  const [selectedCandidates, setSelectedCandidates] = useState(new Set(candidates));

  // Handle Checkbox Selection
  const handleCheckboxChange = (email) => {
    setSelectedCandidates((prevSelected) => {
      const updatedSelection = new Set(prevSelected);
      if (updatedSelection.has(email)) {
        updatedSelection.delete(email); // Deselect if already selected
      } else {
        updatedSelection.add(email); // Select candidate
      }
      return updatedSelection; // Ensure immutability
    });
  };

  // Pass only selected candidates to next step
  const handleConfirm = () => {
    const selectedArray = Array.from(selectedCandidates); // Convert Set to Array
    if (selectedArray.length > 0) {
      onSelectTest(selectedArray); // Pass selected candidates
    }
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className={cn("sm:max-w-[500px]")}>
        <DialogHeader>
          <DialogTitle className={cn("flex items-center gap-2")}>
            <Calendar className="w-5 h-5" />
            <Heading level="h2">Schedule Interview</Heading>
          </DialogTitle>
          <DialogDescription>
            <Text>Do you want to schedule an interview with {len === 0 ? 1 : len} candidate(s)?</Text>
          </DialogDescription>
        </DialogHeader>

        {/* ✅ Scrollable Candidate List */}
        <div className={cn("max-h-64 overflow-y-auto space-y-2")}>
          {candidates.length > 0 ? (
            candidates.map((candidate) => (
              <div key={candidate} className={cn("flex items-center gap-3 p-2 rounded-md hover:bg-gray-50")}>
                <Checkbox
                  checked={selectedCandidates.has(candidate)}
                  onCheckedChange={() => handleCheckboxChange(candidate)}
                />
                <img src="user.jpg" alt="PFP" className={cn("w-10 h-10 rounded-full")} />
                <Text className={cn("flex-1")}>{candidate}</Text>
              </div>
            ))
          ) : 
          (
            <Text className={cn("text-center text-gray-500 py-4")}>No candidates available</Text>
          )}
        </div>

        {/* ✅ Action Buttons */}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={selectedCandidates.size === 0}
          >
            Select Test
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleInterviewModal;